module.exports = __webpack_public_path__ + "img/CRC1_B.2e8e8f51.png";